module.exports = __webpack_public_path__ + "s/img/icon-empty.eb42237.png";


//////////////////
// WEBPACK FOOTER
// ./static/components/search/assets/icon-empty.png
// module id = 225
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 13 14 16 17 19 21 26 28 29 31 36 37 40 42